(function () {
  function syncCheckoutTotal() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var subtotal = drawer.querySelector('[data-subtotal]');
    var checkoutTotal = drawer.querySelector('[data-checkout-total]');
    if (!subtotal || !checkoutTotal) return;

    checkoutTotal.innerHTML = subtotal.innerHTML;
  }

  function initCheckoutTotalSync() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    syncCheckoutTotal();

    var subtotal = drawer.querySelector('[data-subtotal]');
    if (subtotal && !subtotal.dataset.csCheckoutSync) {
      subtotal.dataset.csCheckoutSync = 'true';
      new MutationObserver(syncCheckoutTotal).observe(subtotal, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  document.addEventListener('cart:updated', syncCheckoutTotal);
  document.addEventListener('cart:build', syncCheckoutTotal);
  document.addEventListener('DOMContentLoaded', initCheckoutTotalSync);
  document.addEventListener('shopify:section:load', initCheckoutTotalSync);
})();
